export const GENERAL_EVENTS = {
  TRACK_FEATURE_USAGE: 'trackFeatureUsage',
  TRACK_WEB_VITAL: 'trackWebVital',
  TRACK_SURVEY: 'trackSurvey',
};
